export class MegapushUtils {
    public static transformContent(content: string, color?: string, isMobile?: boolean): string {
        // Construire les classes pour le prix en fonction de la couleur et du mode mobile
        const priceClasses = ['ob1-price'];
        if (color === 'text-white') {
            priceClasses.push('ob1-price-inverse');
        }
        if (isMobile) {
            priceClasses.push('ob1-price-compact');
        }
        const priceClassString = priceClasses.join(' ');

        const pattern: any = {
            '[bold]': '<strong>',
            '[/bold]': '</strong>',
            '[color]': '<span class="text-primary">',
            '[/color]': '</span>',
            '[prix]': `<div class="${priceClassString}" data-ob1-component="Price"> <span class="ob1-price-amount">`,
            '[/prix]': '&nbsp;</span></div>',
            '[retour]': '</br>',
            '[tagblack]': '<strong class="ob1-tag ob1-tag-information">',
            '[/tagblack]': '</strong>',
            '[tagyellow]': '<strong class="ob1-tag ob1-tag-primary">',
            '[/tagyellow]': '</strong>',
            '[tagwhite]': '<strong class="ob1-tag ob1-tag-inverse ob1-tag-information">',
            '[/tagwhite]': '</strong>',
        };

        if (!content) {
            return '';
        }
        const transformed = content?.replaceAll(
            /\[bold]|\[\/bold]|\[color]|\[\/color]|\[prix]|\[\/prix]|\[retour]|\[tagblack]|\[\/tagblack]|\[tagyellow]|\[\/tagyellow]|\[tagwhite]|\[\/tagwhite]/g,
            (matched) => pattern[matched],
        );
        return color ? `<span class="${color}">${transformed}</span>` : transformed;
    }
}
